/**
 * @author3173
 * @description 远程认证管理页面配置
 * @Date 2020/8/12
 */
import React from 'react'
import {component_tool, framework_tool} from '@/tool';
import {WizTableForm} from '@/containers/common';
import moment from "moment";
import ExportFileList from './exportFileList'

const organizationConfig = WizTableForm.Config.organizationByNoFilter(this, {
  apiParams: {
    state: 1,
    organizationNodeCategory: ["2"]
  }
})
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}

let {WizModal} = component_tool;
let ref_;

//配置项
let componentName = 'remoteAuth'
const columns = [
  {
    name: "id",
    fromItem: {
      type: "hidden"
    }
  },
  {
    title: "检核项目",
    name: "name",
    searchItem: {},
    tableItem: {
      width: 200
    },
  },
  {
    title: "检核类型",
    name: "type",
    searchItem: {
      type: 'select',
    },
    tableItem: {
      width: 200
    },
    dict: [
      {code: 0, codeName: '远程认证'},
      {code: 1, codeName: '远程评估'},
      {code: 2, codeName: 'NEV认证'},
    ]
  },

  {
    title: "品牌",
    name: "orgName",
    tableItem: {
      width: 130
    },
  },
  {
    title: "品牌",
    name: "orgIds",
    searchItem: {
      diy: WizTableForm,
      //selectType: "radio",
      ...organizationConfig
    }
  },
  {
    title: "考评场次",
    name: "studentCount",
    tableItem: {width: 100},
  },
  {
    title: "考卷上传人",
    name: "examCreatorName",
    searchItem: {},
    tableItem: {width: 100},
  },
  {
    title: "上传日期",
    name: "examCreateDate",
    tableItem: {
      width: 150,
      render: (text, record) => {
        return formatterDate(text)
      }
    },
  },
  {
    title: "考卷数",
    name: "examCount",
    tableItem: {
      width: 100,
      render: (text, record) => {
        if (record.type === 0) {
          return text
        } else {
          return text > 0 ? 1 : 0
        }
      }
    },
  },
  {
    title: "通过分数",
    name: "passScore",
    tableItem: {},
  },
  {
    title: '上传日期',
    name: 'openTime',
    searchItem: {
      type: 'date~',
      showTime: false,
      format: 'YYYY-MM-DD'
    },
  }

];

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        //btnAccessCheck: false,
        searchBarProps: {
          dataFormat: (v) => {
            let value = Object.assign([], v)
            if (value['openTime'] && value['openTime'].length === 2) {
              value['startDate'] = moment(value['openTime'][0]).format("YYYY-MM-DD");
              value['endDate'] = moment(value['openTime'][1]).format("YYYY-MM-DD");
            }
            return value
          },
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          buttonSort: ['add', 'export'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: {icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/remoteAuth/remoteAuthList/remoteAuthDetailAdd'
                }
              }
            },
            {
              key: "export",
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['update', 'examPaperUpload', 'examPaperExport', 'analysisReport', 'reportDetails', 'viewCertificationDetails'], //'exportDetail'
        rowOperateView: [
          {
            key: "update",
            custom: true,
            params: {children: "编辑"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/remoteAuth/remoteAuthList/remoteAuthDetailUpd"
              }
            }
          },
          {
            key: "examPaperUpload",
            custom: true,
            params: {children: "考卷上传"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/remoteAuth/remoteAuthList/remoteAuthFileImport"
              }
            }
          },
          {
            key: "examPaperExport",
            custom: true,
            params: {children: "考卷导出"},
            customOnClick: {
              key: "modal",
              params: {
                modalKey: 'exportModal',
                modalParams: {
                  title: "考卷",
                  diy: (e) => {
                    return (
                      <ExportFileList
                        key={e.record.id+ "_" + self.state.lookDownTimestamp}
                        {...e}
                        ref={r => {
                          ref_ = r && r.getWrappedInstance();
                        }}
                      />
                    )
                  },
                  onOk: () => {
                    ref_.downloadFile();
                    self.setState({ lookDownTimestamp: new Date().getTime() })
                  },
                  onCancel: () => {
                    self.setState({ lookDownTimestamp: new Date().getTime() })
                  },
                  width: 700
                }
              },
              formatParams: (rows, record, filter) => {
                return {...record};
              }
            }
          },
          {
            key: "reportDetails",
            custom: true,
            params: {children: "报告明细"},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'report',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return {remoteAuthId: record.id}
              }
            },
            recordChangeParams: ({record, rows}) => {
              let disabled = record.type;
              let hidden = record.type;
              if (record.type != null && record.type === 2) {
                disabled = true;
                hidden = true;
              }
              return {disabled: disabled, hidden: hidden}
            },
          },
          {
            key: "analysisReport",
            custom: true,
            params: {children: "分析报告"},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'reportNew',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return {remoteAuthId: record.id, type: record.type}
              }
            },
            recordChangeParams: ({record, rows}) => {
              let disabled = false;
              let hidden = false;
              if (record.type != null && record.type === 2) {
                disabled = true;
                hidden = true;
              }
              return {disabled: disabled, hidden: hidden}
            },
          },
          {
            key: "viewCertificationDetails",
            custom: true,
            params: {children: "查看详情"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/remoteAuth/remoteAuthList/studentRemoteAuthDetailList"
              },
            },
            recordChangeParams: ({record, rows}) => {
              let disabled = true;
              let hidden = true;
              if (record.type != null && record.type === 0) {
                disabled = false;
                hidden = false;
              }
              return {disabled: disabled, hidden: hidden}
            },
          },
          {
            key: "viewCertificationDetails",
            custom: true,
            params: {children: "查看详情"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/remoteAuth/remoteAuthList/orgRemoteEvaluationDetailList"
              },
            },
            recordChangeParams: ({record, rows}) => {
              let disabled = true;
              let hidden = true;
              if (record.type != null && record.type === 1) {
                disabled = false;
                hidden = false;
              }
              return {disabled: disabled, hidden: hidden}
            },
          },

          {
            key: "viewCertificationDetails",
            custom: true,
            params: {children: "查看详情"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/remoteAuth/remoteAuthList/nevRemoteAuthDetail"
              },
            },
            recordChangeParams: ({record, rows}) => {
              let disabled = true;
              let hidden = true;
              if (record.type != null && record.type === 2) {
                disabled = false;
                hidden = false;
              }
              return {disabled: disabled, hidden: hidden}
            },
          },
        ]
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  report: {
    path: `studentRemoteAuthDetail/remoteAuthReport`,
    payload: {
      key: `studentRemoteAuthDetail@remoteAuthReport`,
      apiParams: {}
    }
  },
  reportNew: {
    path: `studentRemoteAuthDetail/exportRemoteAuthInfo`,
    payload: {
      key: `studentRemoteAuthDetail@exportRemoteAuthInfo`,
      apiParams: {}
    }
  }
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
